/* eslint-disable import/prefer-default-export */
import PropTypes from 'prop-types';

const CommentProp = {
  id: PropTypes.number,
  parent: PropTypes.number,
  date_add: PropTypes.string,
  date_add_human: PropTypes.string,
  user_add: PropTypes.number,
  user_add_name: PropTypes.string,
  user_karma: PropTypes.number,
  post: PropTypes.string,
  rating: PropTypes.number,
  on_moderation: PropTypes.number,
  user_ip: PropTypes.string,
  public: PropTypes.bool,
  paid: PropTypes.bool,
  forum_post_id: PropTypes.number,
  rating_p: PropTypes.number,
  rating_m: PropTypes.number,
  country: PropTypes.string,
  reply_to_user: PropTypes.number,
  reply_to_name: PropTypes.string,
  canEdit: PropTypes.bool,
  isNew: PropTypes.bool
};

export {
  CommentProp
};
